module.exports = __webpack_public_path__ + "teqbahn-assets/media/3_2_new.0b2af895.jpg";